import BaseModel from "@/core/components/input-widget/BaseModel";
import i18n from "@/shared/i18n";


export default class ChargeTier extends BaseModel {
  amount_over = 0;
  fixed_amount = null;
  percent = null;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  getData() {
    return {
      amount_over: parseFloat(this.amount_over),
      fixed_amount: parseFloat(this.fixed_amount),
      percent: parseFloat(this.percent),
    };
  }

  rules = {
    amount_over: 'required',
  };

  attributeLabels = {
    amount_over: i18n.t('Over'),
    fixed_amount: i18n.t('Fixed Amount'),
    percent: i18n.t('Percentage'),
  };
}